/**************************************************
 * Nombre:       Formacion_Perfil_Ocupacional
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Button, Grid, Typography} from "@mui/material";
import {theme} from "../../../Tema";
import iso from "../../../Recursos/iso_azul.svg";
import {NEGRITA} from "../../../Constantes";
import Tarjeta_Perfil_Ocupacional from "../../Tarjetas/Tarjeta_Perfil_Ocupacional";
import {useDialogo} from "../../../Modulo_Dialogos_2025/Hooks/useDialogo";
import Dialogo_Wass from "../../Dialogos/Dialogo_Wass";
import {useResponsive} from "../../../Modulo_responsive/Hooks/useResponsive";


const Formacion_Perfil_Ocupacional = () => {
    const {sCell} = useResponsive()
    const {Dialogo, abrir} = useDialogo({Componente: Dialogo_Wass, titulo: 'Inciar Conversación'})

    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Dialogo/>

            {!sCell && <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 9}}
                sx={{
                    backgroundColor: theme.palette.primary.main,
                    p: 3,
                    minHeight: 350,
                }}

            >

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-end'}}>
                    <Button
                        onClick={() => abrir({asunto: 'Pefil ocupacion del tecnico'})}
                        color={'secondary'}
                        startIcon={<img src={iso} style={{width: 24, height: 24, marginRight: 10}}/>}>
                        Mas informacion
                    </Button>
                </Grid>


            </Grid>
            }

            <Grid
                container
                justifyContent={'center'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{maxWidth: '1400px', px: 3, color: '#fff'}}
            >


                <Grid container size={{xs: 12, sm: 12, md: 11}}
                      sx={{justifyContent: 'flex-start', mt: sCell ? 0 : -36}}>
                    <Grid
                        container
                        justifyContent={'flex-start'}
                        alignItems={'flex-start'}
                        size={{xs: 12, sm: 12, md: 12}}
                        sx={{
                            backgroundColor: sCell ? theme.palette.primary.main : '#ffffff00',
                            p: sCell ? 6 : 0,
                            pb: sCell ? 20 : 0,
                            width: sCell ? '120%' : 'auto',
                            marginLeft: sCell ? -4 : 0,
                            marginRight: sCell ? -4 : 0,
                        }}
                    >

                        <Grid
                            container
                            justifyContent={'flex-start'}
                            alignItems={'flex-start'}
                            size={{xs: 12, sm: 12, md: 12}}>


                            <Grid container size={{xs: 12, sm: 12, md: 12}}
                                  sx={{justifyContent: sCell ? 'center' : 'flex-start'}}>
                                <Typography sx={{
                                    fontFamily: NEGRITA,
                                    fontSize: sCell ? 40 : 48,
                                    fontWeight: 600,
                                    lineHeight: 1.1,
                                    textAlign: sCell ? 'center' : 'left'
                                }}>
                                    PerFIL OCUPACIONAL
                                </Typography>
                            </Grid>

                            <Grid container size={{xs: 12, sm: 12, md: 6}} sx={{justifyContent: 'flex-start', mt: 1}}>
                                <Typography sx={{fontSize: 18, fontWeight: 400, textAlign: sCell ? 'center' : 'left'}}>
                                    Programas prácticos diseñados para una empleabilidad rápida en sectores clave como
                                    tecnología, administración, salud e industria
                                    Programas prácticos diseñados para una empleabilidad rápida en sectores clave como
                                    tecnología, administración, salud e industria,

                                </Typography>
                            </Grid>


                            {sCell &&
                                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center', mt: 4}}>
                                    <Button
                                        onClick={() => abrir({asunto: 'Pefil ocupacion del tecnico'})}
                                        color={'secondary'}
                                        startIcon={<img src={iso} style={{width: 24, height: 24, marginRight: 10}}/>}>
                                        Mas informacion
                                    </Button>
                                </Grid>
                            }

                        </Grid>



                    </Grid>

                    <Grid
                        container
                        justifyContent={'flex-start'}
                        alignItems={'flex-start'}
                        size={{xs: 12, sm: 12, md: 12}}
                        spacing={4}
                        sx={{mt: sCell ? -12 : 6}}
                    >

                        {items.map((item, index) => (
                            <Grid container size={{xs: 12, sm: 12, md: 4}} sx={{justifyContent: 'flex-start'}}>
                                <Tarjeta_Perfil_Ocupacional/>
                            </Grid>
                        ))}

                    </Grid>

                </Grid>

            </Grid>

        </Grid>
    )

}
export default Formacion_Perfil_Ocupacional

const items = [1, 2, 3]